export default __webpack_public_path__ + "static/AvenirLTStd-Heavy-6bec98e0ddc9a0e0317694d654ad75ae.woff";